@if (safePdfUrl) {
<iframe [src]="safePdfUrl"
    width="100%"
    height="100%">
    
</iframe>
}